import { Panel } from "components/Panel/Panel";
import { Pick } from "model/Pickem/Pickem";
import { PointsPartition } from "model/PickemDetails/PointsPartition";
import { RankemGrid } from "./Grid/RankemGrid";
import { RankemDetails } from "model/PickemDetails/Rankem/Details";
import { selectPickemMatchIdsFromSwiss } from "selectors/PickemDetails";
import { onlyUnique } from "Utility";
import { selectRosterDisplayName } from "selectors/Roster";
import { selectMatchesRosterIds } from "selectors/Match";
import { useAppSelector } from "app/hooks";
import { Swiss } from "model/Tournament/Segment/Swiss/Swiss";

interface Props {
  details: RankemDetails;
  swiss: Swiss;
  columns: PointsPartition[];
  picks: {
    [id: string]: Pick;
  };
  updatePick: (
    rosterId: string,
    groupRosterIds: string[],
    position: number | undefined
  ) => void;
}

export const SwissRankemPicker = ({
  details,
  swiss,
  columns,
  picks,
  updatePick,
}: Props) => {
  const rosterIds = useAppSelector((state) => {
    const matchIds = selectPickemMatchIdsFromSwiss(state, swiss, details);
    const rosterIds = selectMatchesRosterIds(state, matchIds)
      .concat(details.additionalRosterIds ?? [])
      .filter(onlyUnique);
    return rosterIds.sort((a, b) =>
      (
        selectRosterDisplayName(state, a, details.tournamentId) ?? ""
      ).localeCompare(
        selectRosterDisplayName(state, b, details.tournamentId) ?? ""
      )
    );
  });

  return (
    <Panel header={swiss.name} padding="padded">
      <RankemGrid
        columns={columns}
        gridRosterIds={rosterIds}
        picks={picks}
        updatePick={(rosterId, position) =>
          updatePick(rosterId, rosterIds, position)
        }
        frozenRosters={{}}
        tournamentId={details.tournamentId}
      />
    </Panel>
  );
};
